import * as j from "react";
import z from "react";
import { g as X } from "./chunk.CKXGCgA0.js";
import { _ as l, a as O } from "./chunk.Czw-e4a5.js";
import { P as e } from "./chunk.C6tu0KW1.js";
import { s as Y, u as Z, a as _, b as H, c as ee, d as oe, e as se, g as te, f as re, P as ae, h as N, i as ne, j as le, k as F, l as A, m as ie, n as ue, o as ce, r as me, C as de, p as pe, q as fe, t as be, v as Te } from "./chunk.Kz7tWOuN.js";
import { useThemeProps as V, styled as $, useTheme as Pe } from "@mui/material/styles";
import { v as q, P as he, a as w, r as ve, b as B, c as xe } from "./chunk.BNjWKpq_.js";
import { jsx as k, jsxs as S } from "react/jsx-runtime";
import Ce from "@mui/material/TextField";
const ye = (o) => {
  var s, u, c, a;
  const d = _(), n = ((s = o.ampm) != null ? s : d.is12HourCycleInCurrentLocale()) ? d.formats.fullTime12h : d.formats.fullTime24h;
  return l({}, o, {
    disablePast: (u = o.disablePast) != null ? u : !1,
    disableFuture: (c = o.disableFuture) != null ? c : !1,
    format: (a = o.format) != null ? a : n
  });
}, ge = ({
  props: o,
  inputRef: s
}) => {
  const u = ye(o), {
    forwardedProps: c,
    internalProps: a
  } = Y(u, "time");
  return Z({
    inputRef: s,
    forwardedProps: c,
    internalProps: a,
    valueManager: H,
    fieldValueManager: ee,
    validator: q,
    valueType: "time"
  });
}, ke = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"], Le = ["inputRef"], Me = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Re = /* @__PURE__ */ j.forwardRef(function(s, u) {
  var c, a, d;
  const r = V({
    props: s,
    name: "MuiTimeField"
  }), {
    slots: n,
    slotProps: t,
    components: m,
    componentsProps: p,
    InputProps: i,
    inputProps: f
  } = r, h = O(r, ke), b = r, v = (c = (a = n == null ? void 0 : n.textField) != null ? a : m == null ? void 0 : m.TextField) != null ? c : Ce, y = oe({
    elementType: v,
    externalSlotProps: (d = t == null ? void 0 : t.textField) != null ? d : p == null ? void 0 : p.textField,
    externalForwardedProps: h,
    ownerState: b
  }), {
    inputRef: L
  } = y, T = O(y, Le);
  T.inputProps = l({}, f, T.inputProps), T.InputProps = l({}, i, T.InputProps);
  const M = ge({
    props: T,
    inputRef: L
  }), {
    ref: R,
    onPaste: x,
    onKeyDown: P,
    inputMode: C,
    readOnly: g,
    clearable: K,
    onClear: G
  } = M, D = O(M, Me), {
    InputProps: J,
    fieldProps: Q
  } = se({
    onClear: G,
    clearable: K,
    fieldProps: D,
    InputProps: D.InputProps,
    slots: n,
    slotProps: t,
    components: m,
    componentsProps: p
  });
  return /* @__PURE__ */ k(v, l({
    ref: u
  }, Q, {
    InputProps: l({}, J, {
      readOnly: g
    }),
    inputProps: l({}, D.inputProps, {
      inputMode: C,
      onPaste: x,
      onKeyDown: P,
      ref: R
    })
  }));
});
function Fe(o) {
  return re("MuiTimePickerToolbar", o);
}
const I = te("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), we = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], Ie = (o) => {
  const {
    theme: s,
    isLandscape: u,
    classes: c
  } = o, a = {
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", u && "hourMinuteLabelLandscape", s.direction === "rtl" && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", u && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return ie(a, Fe, c);
}, Oe = $(ae, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (o, s) => s.root
})({}), _e = $(he, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (o, s) => s.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), U = $("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (o, s) => [{
    [`&.${I.hourMinuteLabelLandscape}`]: s.hourMinuteLabelLandscape,
    [`&.${I.hourMinuteLabelReverse}`]: s.hourMinuteLabelReverse
  }, s.hourMinuteLabel]
})(({
  theme: o,
  ownerState: s
}) => l({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end"
}, s.isLandscape && {
  marginTop: "auto"
}, o.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
U.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: e.elementType,
  ownerState: e.object.isRequired,
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
};
const W = $("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (o, s) => [{
    [`.${I.ampmLabel}`]: s.ampmLabel
  }, {
    [`&.${I.ampmLandscape}`]: s.ampmLandscape
  }, s.ampmSelection]
})(({
  ownerState: o
}) => l({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, o.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  flexBasis: "100%"
}, {
  [`& .${I.ampmLabel}`]: {
    fontSize: 17
  }
}));
W.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: e.elementType,
  ownerState: e.object.isRequired,
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
};
function $e(o) {
  const s = V({
    props: o,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: u,
    ampmInClock: c,
    value: a,
    isLandscape: d,
    onChange: r,
    view: n,
    onViewChange: t,
    views: m,
    disabled: p,
    readOnly: i,
    className: f
  } = s, h = O(s, we), b = _(), v = N(), y = Pe(), L = !!(u && !c && m.includes("hours")), {
    meridiemMode: T,
    handleMeridiemChange: M
  } = ne(a, u, r), R = (g) => u ? b.format(g, "hours12h") : b.format(g, "hours24h"), x = s, P = Ie(l({}, x, {
    theme: y
  })), C = /* @__PURE__ */ k(_e, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: P.separator
  });
  return /* @__PURE__ */ S(Oe, l({
    landscapeDirection: "row",
    toolbarTitle: v.timePickerToolbarTitle,
    isLandscape: d,
    ownerState: x,
    className: le(P.root, f)
  }, h, {
    children: [/* @__PURE__ */ S(U, {
      className: P.hourMinuteLabel,
      ownerState: x,
      children: [F(m, "hours") && /* @__PURE__ */ k(w, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => t("hours"),
        selected: n === "hours",
        value: a ? R(a) : "--"
      }), F(m, ["hours", "minutes"]) && C, F(m, "minutes") && /* @__PURE__ */ k(w, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => t("minutes"),
        selected: n === "minutes",
        value: a ? b.format(a, "minutes") : "--"
      }), F(m, ["minutes", "seconds"]) && C, F(m, "seconds") && /* @__PURE__ */ k(w, {
        variant: "h3",
        onClick: () => t("seconds"),
        selected: n === "seconds",
        value: a ? b.format(a, "seconds") : "--"
      })]
    }), L && /* @__PURE__ */ S(W, {
      className: P.ampmSelection,
      ownerState: x,
      children: [/* @__PURE__ */ k(w, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: T === "am",
        typographyClassName: P.ampmLabel,
        value: A(b, "am"),
        onClick: i ? void 0 : () => M("am"),
        disabled: p
      }), /* @__PURE__ */ k(w, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: T === "pm",
        typographyClassName: P.ampmLabel,
        value: A(b, "pm"),
        onClick: i ? void 0 : () => M("pm"),
        disabled: p
      })]
    })]
  }));
}
function De(o, s) {
  var u, c, a, d, r;
  const n = _(), t = V({
    props: o,
    name: s
  }), m = (u = t.ampm) != null ? u : n.is12HourCycleInCurrentLocale(), p = j.useMemo(() => {
    var h;
    return ((h = t.localeText) == null ? void 0 : h.toolbarTitle) == null ? t.localeText : l({}, t.localeText, {
      timePickerToolbarTitle: t.localeText.toolbarTitle
    });
  }, [t.localeText]), i = (c = t.slots) != null ? c : ue(t.components), f = (a = t.slotProps) != null ? a : t.componentsProps;
  return l({}, t, {
    ampm: m,
    localeText: p
  }, ce({
    views: t.views,
    openTo: t.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: (d = t.disableFuture) != null ? d : !1,
    disablePast: (r = t.disablePast) != null ? r : !1,
    slots: l({
      toolbar: $e
    }, i),
    slotProps: l({}, f, {
      toolbar: l({
        ampm: m,
        ampmInClock: t.ampmInClock
      }, f == null ? void 0 : f.toolbar)
    })
  });
}
const E = /* @__PURE__ */ j.forwardRef(function(s, u) {
  var c, a, d, r, n, t;
  const m = N(), p = _(), i = De(s, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: f,
    views: h,
    timeSteps: b
  } = ve(i), v = f ? xe : B, y = l({
    hours: v,
    minutes: v,
    seconds: v,
    meridiem: v
  }, i.viewRenderers), L = (c = i.ampmInClock) != null ? c : !0, T = f ? [] : ["accept"], R = ((a = y.hours) == null ? void 0 : a.name) === B.name ? h : h.filter((C) => C !== "meridiem"), x = l({}, i, {
    ampmInClock: L,
    timeSteps: b,
    viewRenderers: y,
    format: me(p, i),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: f ? ["hours"] : R,
    slots: l({
      field: Re,
      openPickerIcon: de
    }, i.slots),
    slotProps: l({}, i.slotProps, {
      field: (C) => {
        var g;
        return l({}, pe((g = i.slotProps) == null ? void 0 : g.field, C), fe(i), {
          ref: u
        });
      },
      toolbar: l({
        hidden: !0,
        ampmInClock: L
      }, (d = i.slotProps) == null ? void 0 : d.toolbar),
      actionBar: l({
        actions: T
      }, (r = i.slotProps) == null ? void 0 : r.actionBar)
    })
  }), {
    renderPicker: P
  } = be({
    props: x,
    valueManager: H,
    valueType: "time",
    getOpenDialogAriaText: (n = (t = x.localeText) == null ? void 0 : t.openTimePickerDialogue) != null ? n : m.openTimePickerDialogue,
    validator: q
  });
  return P();
});
E.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: e.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: e.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  /**
   * Class name applied to the root element.
   */
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: e.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: e.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Te,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: e.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: e.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: e.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number, e.shape({
    endIndex: e.number.isRequired,
    startIndex: e.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: e.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: e.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: e.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: e.shape({
    hours: e.number,
    minutes: e.number,
    seconds: e.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: e.shape({
    hours: e.func,
    meridiem: e.func,
    minutes: e.func,
    seconds: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const Ue = (o) => {
  const s = z.useRef(null), u = (r) => {
    const { helperText: n } = o;
    if (r)
      return typeof n == "string" ? n : typeof n == "function" ? n(r) : void 0;
  }, c = (r) => {
    var m, p, i;
    const n = (m = r == null ? void 0 : r.InputProps) == null ? void 0 : m.ref, t = (p = n == null ? void 0 : n.current) == null ? void 0 : p.firstElementChild;
    return (i = t == null ? void 0 : t.placeholder) == null ? void 0 : i.toLowerCase();
  }, a = (r) => {
    o.onChange && o.onChange(r);
  };
  function d() {
    var r;
    if (s.current) {
      const n = {
        target: s.current
      };
      (r = o.onBlur) == null || r.call(o, n);
    }
  }
  return /* @__PURE__ */ z.createElement(
    E,
    {
      inputRef: s,
      label: o.label,
      value: o.value,
      disabled: o.disabled,
      readOnly: o.readOnly,
      maxTime: o.maxTime,
      minTime: o.minTime,
      ampm: !o.use24HourTime,
      onChange: a,
      onError: o.onError,
      onClose: d,
      timeSteps: o.timeSteps,
      slotProps: {
        textField: (r) => ({
          id: o.id,
          autoFocus: o.autoFocus,
          helperText: u(c(r)),
          inputProps: {
            "data-testid": o["data-testid"]
          },
          error: o.error || (r == null ? void 0 : r.error),
          required: o.required,
          onBlur: o.onBlur,
          fullWidth: o.fullWidth,
          // this doesn't seem to work, so the sx below helps out
          sx: {
            maxWidth: o.fullWidth ? "100%" : void 0
          },
          clearable: o.clearable,
          size: X(o.size)
        })
      }
    }
  );
};
export {
  Ue as U
};
